import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import KanbanColumn from './KanbanColumn';

const useStyles = makeStyles(theme => ({
  board: {
    display: 'flex',
    overflowX: 'auto',
    overflowY: 'hidden',
    flex: 1,
    paddingBottom: 16,
    '&::-webkit-scrollbar': {
      height: 6,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#d4d4d4',
      borderRadius: 3,
    },
  },
}));

const KanbanBoard = ({ lanes, onCardMove, onLaneReorder, updateTicket, removeTicket, isAdmin, onAddColumn, onAddToColumn, connections }) => {
  const classes = useStyles();

  const handleDragEnd = result => {
    if (!result.destination) return;
    const { source, destination, draggableId, type } = result;

    if (type === 'LANE') {
      if (source.index !== destination.index) {
        onLaneReorder(source.index, destination.index);
      }
      return;
    }

    if (
      source.droppableId !== destination.droppableId ||
      source.index !== destination.index
    ) {
      onCardMove(draggableId, destination.droppableId, source.droppableId, source.index, destination.index);
    }
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="lanes" direction="horizontal" type="LANE">
        {(provided) => (
          <div
            className={classes.board}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {lanes.map((lane, index) => (
              <KanbanColumn
                key={lane.id}
                id={lane.id}
                title={lane.title}
                tickets={lane.tickets}
                color={lane.color}
                index={index}
                updateTicket={updateTicket}
                removeTicket={removeTicket}
                isAdmin={isAdmin}
                onAddToColumn={onAddToColumn}
                connections={connections}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default KanbanBoard;
